import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInterviewStore } from '../store';
import { InterviewConfig as IInterviewConfig } from '../types';

export function InterviewConfig() {
  const { t } = useTranslation();
  const config = useInterviewStore((state) => state.interviewConfig);
  const updateConfig = useInterviewStore((state) => state.updateConfig);

  const handleConfigChange = (key: keyof IInterviewConfig, value: any) => {
    updateConfig({ [key]: value });
  };

  return (
    <div className="bg-white shadow rounded-lg p-6 space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">
        {t('interview.config.title')}
      </h2>

      <div className="space-y-4">
        {/* Language selection */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            {t('interview.config.language')}
          </label>
          <select
            value={config.language}
            onChange={(e) => handleConfigChange('language', e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          >
            <option value="en">English</option>
            <option value="es">Español</option>
          </select>
        </div>

        {/* Interview tone */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            {t('interview.config.tone.label')}
          </label>
          <select
            value={config.tone}
            onChange={(e) => handleConfigChange('tone', e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          >
            <option value="formal">{t('interview.config.tone.formal')}</option>
            <option value="casual">{t('interview.config.tone.casual')}</option>
            <option value="friendly">{t('interview.config.tone.friendly')}</option>
          </select>
        </div>

        {/* Technical depth */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            {t('interview.config.technicalDepth.label')}
          </label>
          <select
            value={config.technicalDepth}
            onChange={(e) => handleConfigChange('technicalDepth', e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          >
            <option value="basic">{t('interview.config.technicalDepth.basic')}</option>
            <option value="intermediate">{t('interview.config.technicalDepth.intermediate')}</option>
            <option value="advanced">{t('interview.config.technicalDepth.advanced')}</option>
          </select>
        </div>

        {/* Number of questions */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            {t('interview.config.duration')}
          </label>
          <input
            type="number"
            min="3"
            max="10"
            value={config.duration}
            onChange={(e) => handleConfigChange('duration', parseInt(e.target.value, 10))}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          />
        </div>

        {/* Custom questions */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            {t('interview.config.customQuestions')}
          </label>
          <textarea
            value={config.customQuestions.join('\n')}
            onChange={(e) => handleConfigChange('customQuestions', e.target.value.split('\n').filter(q => q.trim()))}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
            rows={4}
            placeholder={t('jobDescription.onePerLine')}
          />
        </div>
      </div>
    </div>
  );
}